import React from "react";
import classNames from "classnames";
import type { CSSProperties } from "react";
import normalClasses from "../../Normal/NormalMode/NormalMode.module.scss";
import styles from "./ChildrenModeCardSpace.module.scss";

export type ChildrenModeIconMeta = {
  src: string;
  objectFit: "contain" | "cover" | "fill";
  objectPosition: string;
  scale: number;
};

type ChildrenModeCardSpaceProps = {
  className?: string;
  isCategory: boolean;
  isService: boolean;
  isActiveNow: boolean;
  shouldHideOuterCircle: boolean;
  ticketCircleStyle?: CSSProperties;

  ticketName: string;
  isChildrenMode: boolean;
  childrenIconMeta: ChildrenModeIconMeta | null;
  childrenTileColor?: string;
  childrenTileTextColor?: string;
  planetHueRotate?: number;
};

export const ChildrenModeCardSpace: React.FC<ChildrenModeCardSpaceProps> = ({
  className,
  isCategory,
  isService,
  isActiveNow,
  shouldHideOuterCircle,
  ticketCircleStyle,
  ticketName,
  isChildrenMode,
  childrenIconMeta,
  planetHueRotate = 0,
}) => {
  const hasIcon = Boolean(childrenIconMeta);

  return (
    <div
      className={classNames(styles.root, className, {
        [styles.withIcon]: hasIcon,
        [normalClasses.active]: isService && isActiveNow,
        [normalClasses.ticketCardCompact]:
          shouldHideOuterCircle && !isChildrenMode,
      })}
      style={
        {
          "--space-card-hue-rotate": `${planetHueRotate}deg`,
          "--space-card-texture": `url(${process.env.PUBLIC_URL}/children-texture/planet-texture.svg)`,
        } as CSSProperties
      }
    >
      {childrenIconMeta ? (
        <div
          className={classNames(
            normalClasses.childrenModeIconSlot,
            styles.iconSlot,
          )}
        >
          <img
            className={normalClasses.childrenModeIconImage}
            src={childrenIconMeta.src}
            alt=""
            draggable={false}
            style={{
              objectFit: childrenIconMeta.objectFit,
              objectPosition: childrenIconMeta.objectPosition,
              ...(childrenIconMeta.scale !== 100
                ? { transform: `scale(${childrenIconMeta.scale / 100})` }
                : {}),
            }}
          />
        </div>
      ) : (
        !shouldHideOuterCircle && (
          <div
            className={classNames(styles.outerCircle, {
              [normalClasses.ticketOuterCircleSmall]: !isCategory,
              [normalClasses.ticketOuterCircleLarge]: isCategory,
              [styles.outerCircleSmall]: !isCategory,
              [styles.outerCircleLarge]: isCategory,
            })}
            style={
              {
                ...(ticketCircleStyle ?? {}),
                top: "calc(-34% - 50px)",
              } as CSSProperties
            }
          />
        )
      )}

      <div className={styles.textWrapper}>
        <div className={styles.textScroll}>
          <span
            className={classNames({
              [styles.categoryText]: isCategory,
              [styles.serviceText]: isService,
            })}
          >
            {ticketName}
          </span>
        </div>
      </div>

      <div
        className={classNames({
          [normalClasses.cropLineShow]: !isCategory,
          [normalClasses.cropLineHide]: isCategory,
        })}
      ></div>
    </div>
  );
};
